import * as XLSX from "xlsx"
import moment from "moment"

// Shared Excel export for Bank Statement / Credit Card reconcile. `rows` come
// from the backend's /export/entries endpoint, which already resolves each
// match into linked_record / linked_party.

const fmtDate = d => (d && moment(d).isValid() ? moment(d).format("DD-MM-YYYY") : "")

export const exportStatementExcel = ({ rows, typeLabels, sourceHeader, sourceKey, fileName }) => {
    const sheetRows = rows.map(r => ({
        [sourceHeader]: r[sourceKey] || "",
        "Date": fmtDate(r.statement_date),
        "Reference No": r.reference_no || "",
        "Description": r.description || "",
        "Debit": Number(r.debit) || "",
        "Credit": Number(r.credit) || "",
        "Status": r.status === "matched" ? "Matched" : "Unmatched",
        "Mapped To": r.status === "matched" ? typeLabels[r.matched_type] || r.matched_type || "" : "",
        "Linked Record": r.linked_record || "",
        "Client / Category / Account": r.linked_party || "",
        "Notes": r.notes || "",
    }))

    const ws = XLSX.utils.json_to_sheet(sheetRows)
    ws["!cols"] = [18, 12, 18, 45, 12, 12, 11, 24, 32, 28, 30].map(wch => ({ wch }))
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Entries")
    XLSX.writeFile(wb, fileName)
}
